// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OwnerCourses-approve-wrapper[data-v-2a5907be]{text-align:left}.OwnerCourses-wrapper[data-v-2a5907be]{background-color:#fff;padding:5px 15px;border-radius:10px;overflow:auto}label[data-v-2a5907be]{font-weight:500;margin-top:19px;margin-bottom:5px;display:block;text-transform:uppercase;font-size:15px}h3[data-v-2a5907be]{text-transform:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
